import { Injectable } from "@angular/core";
import { SessionStorageService } from "ngx-webstorage";
import { Subject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    color = new Subject<string>();
    
    constructor( 
        private sessionStorageService: SessionStorageService
    ) {
        this.sessionStorageService.store('colr', this.getColor());
        this.updatePropertiesForTheme(this.getTheme(this.getColor()));

        this.color.subscribe(color=>{
            this.sessionStorageService.store('colr', color);
            this.updatePropertiesForTheme(this.getTheme(color));
            // window.location.reload();
        });
    }

    updatePropertiesForTheme(theme:{name:string, props:any}){
        Object.keys(theme.props).forEach(property => {
            document.documentElement.style.setProperty(
                property,
                theme.props[property]
            );
        });
    }

    changeTheme(theme:string){
        this.color.next(theme);
    }

    getColor(): string {
        let color: string = this.sessionStorageService.retrieve('colr');
        if(color === null || color === undefined){
            color = 'pur';
        }
        return color;
    }
    
    getTheme(themeCode: string){
        switch(themeCode){
            case themes.PURP.name:{
                return themes.PURP;
            }
            case themes.BLUE.name:{
                return themes.BLUE
            }
            default: {
                return themes.PURP;
            }
        }
    }
}

export const themes = {
    PURP: {
        name: "pur",
        props:{
            "--primary-color": "#3c71bd",
            "--heading-color": "#1a1c66",
            "--menu-bg-color": "#e1f0f5",
            "--menu-active-color": "#3c71bd",
            "--menu-text-color": "#3c71bd",

            "--bg-top-bar-ribbon" : "#2d5b9d",
            "--bg-even-left-navigation" : "#bdddf0b8",
            "--bg-ticker" : "#ffd4a1",
            "--bg-alt-card": "#3c71bd9c",
            "--bg-footer-middle" : "#3c71bd",
            "--bg-btn-viewall" : "#3c71bd",
            "--bg-white" : "#ffffff",
            "--font-white" : "fff"

            // "--primary-color":"#21238f",
            // "--heading-color": "#1a1c66",
            // "--menu-bg-color": "#d1f5fd",
            // "--menu-active-color": "#d1f5fd",
            // "--menu-text-color": "#310e8f"
        }
    },
    BLUE: {
        name: "bule",
        props:{
            "--primary-color":"#313132",
            "--heading-color": "#313132",
            "--menu-bg-color": "#eaebeb",
            "--menu-active-color": "#d1f5fd",
            "--menu-text-color": "#000000",

            "--bg-top-bar-ribbon" : "#313132",
            "--bg-alt-card" : "#313132b5",
            "--bg-footer-middle" : "#313132",
            "--bg-btn-viewall" : "#313132"
        }
    }
};